import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
//import * as StyledFirebaseAuth from "firebaseui";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';
const config = {
  apiKey: 'AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ',
  authDomain: 'distributed-eye-251310.firebaseapp.com',
};
if (!firebase.apps.length) {
firebase.initializeApp(config);
}
     const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
          firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
	signInSuccessWithAuthResult: function(authResult, redirectUrl) {
	var phone_no = authResult['user']['phoneNumber'];
//	console.log(phone_no);

			//let errors = {};
			const cookies = new Cookies();
      var hosturl = window.location.href;
			//var hosturl = window.location.protocol +"//" + window.location.hostname + "/web";
//	            	var hosturl = "http://app.surulerelove.com:3000/";

			var api_url = localStorage.getItem('api_url');

			var signin = new FormData();
			signin.set('phone', phone_no);
			signin.set('fcmtoken', cookies.get('mytoken'));
			axios({
				method: 'post',
				url: api_url+'webcheckphone',
				data: signin,
				config: { headers: {'Content-Type': 'multipart/form-data' }}
							})
			.then(res => {
				if(res.data.status !== "false"){
					cookies.set('signuptab', 'yes');
					cookies.set('signupmobileno', phone_no);
          hosturl = hosturl.replace('Signupfirebase','');
		                	window.location.href = hosturl+"login";
				}else{
					alert('Sorry, You are already registered this Mobile Number');
					cookies.set('signuptab', 'yes');
          cookies.set('signupmobileno', "");
          hosturl = hosturl.replace('Signupfirebase','');
		                	window.location.href = hosturl+"login";
				}
				
				})


	}	
        }
      };
   
   
   
class Signupfirebase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            api_url:localStorage.getItem('api_url'),
        };
      }

     
    
 
    componentDidMount(){
        const cookies = new Cookies();
       if(cookies.get('onboarded') === 'true'){
         //alert("s");
         this.props.history.push("/app")
           
         
         }else{
            //  this.props.history.push("/login");
            //  window.location.reload();
   
         }
    }
  
  
    render() {
        return (

            <div className="welcomePage">
        

                <div className="welcomePageCenterContent">

                    <div className="welcomeLogo"></div>

                   

<div className="w-100">
 <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
</div>

                    <div class="white-color esmh-14 text-center amt10"><b>By using our services you are agreeing to <span> <NavLink to="/helpmain" className="white-color"> Terms and Conditions </NavLink></span></b></div>


                </div>




            </div>

        );
    }

}




export default Signupfirebase;
